import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { NodeApiCallService } from './node-api-call.service';
import { Observable } from 'rxjs';
import { endPoints } from '../api-end-points';
import { Bookafreedemo } from '../Models/Bookafreedemo';
import { SourceIdEnum } from '../Models/sourceIdEnumModel';

@Injectable({
  providedIn: 'root'
})
export class BookAFreeDemoService {
  constructor(
    private apiService: ApiCallService,
    private nodeApiService: NodeApiCallService
  ) { }

  bookFreeDemo(demoData: Bookafreedemo | any): Observable<any> {
    const payload = {
      Name: String(demoData.Name ?? demoData.name ?? '').trim(),
      Mobile: this.normalizePhoneNumber(demoData.Mobile ?? demoData.mobile ?? demoData.phoneNumber ?? demoData.PhoneNumber),
      Email: String(demoData.Email ?? demoData.email ?? '').trim(),
      Grade: String(demoData.Grade ?? demoData.grade ?? demoData.selectedGrade ?? '').trim(),
      Topic: String(demoData.Topic ?? demoData.topic ?? '').trim(),
      Description: String(demoData.Description ?? demoData.description ?? '').trim(),
      userDetails: demoData.userDetails ?? demoData.UserDetails ?? {},
      ...(demoData.UserId ?? demoData.userId ? { UserId: Number(demoData.UserId ?? demoData.userId) } : {}),
      sourceNameId: Number.isFinite(Number(demoData.sourceNameId)) ? Number(demoData.sourceNameId) : SourceIdEnum.FreeDemo,
      registrationUrl: String(demoData.registrationUrl ?? '/BookAFreeDemo').trim(),
      userTypeId: Number.isFinite(Number(demoData.userTypeId)) ? Number(demoData.userTypeId) : 1,
    };

    return this.nodeApiService.Post(endPoints.BOOK_FREE_DEMO, payload);
  }

  private normalizePhoneNumber(value: any): string {
    return String(value ?? '')
      .trim()
      .replace(/[^\d]/g, '');
  }

  submitConatctUsLead(demoData: any): Observable<any> {
     
    // Construct URL parameters with all required fields
    let para = encodeURI(
      `Name=${demoData.Name}&Mobile=${demoData.PhoneNumber}&Email=${demoData.Email}&Message=${demoData.Message}`
    );

    return this.apiService.Post(
      `${endPoints.SUBMIT_CONTACT_US_PARENT_LEAD}?${para}`,
      null,
      { 'Content-Type': 'text/plain; charset=utf-8' },
      'text'
    );
  }

  submitJuniorHackerParentsLead(demoData: any): Observable<any> { 
    // Construct URL parameters with all required fields
    let para = encodeURI(`Name=${demoData.Name}&Mobile=${demoData.PhoneNumber}&Email=${demoData.Email}&Grade=${demoData.Grade}`);

    return this.apiService.Post(
        `${endPoints.SUBMIT_JUNIOR_HACKER_PARENT_LEAD}?${para}`,
        null,
        { 'Content-Type': 'text/plain; charset=utf-8' },
        'text'
    );
  }
}
